import Dashboard from "../pages/dashboard/dashboard";
import Home from "../pages/home/home";
import { Route } from "../security/route";

export const routes: Route[] = [
  { path: "/training-paths", Component: Dashboard, exact: false },
  { path: "/", Component: Home, exact: false },
];
